import { createMachine, assign } from 'xstate';
import { loyaltyOffersAndRewards } from '../requests/loyalty-offers-and-rewards';

const populateMessage = assign({
  data: (_, payload: any) => {
    const message = payload?.message;
    const error = message?.message;
    const data = payload?.data;

    if (data) {
      logger.debug(`api - loyaltyOffersAndRewards - FSM data recieved:`, data);
      return data;
    }

    if (error) {
      logger.error(`api - loyaltyOffersAndRewards - FSM error recieved:`, error);
      return error;
    }

    logger.error(`api - loyaltyOffersAndRewards - FSM message recieved:`, message);
    return message;
  },
});

const createLoyaltyOffersAndRewardsMachine = ({ token = '', storeId = '' } = {}) =>
  createMachine<{
    token: string;
    storeId: string;
  }>(
    {
      id: 'loyaltyOffersAndRewards',
      initial: 'processing',
      context: {
        token,
        storeId,
      },
      states: {
        processing: {
          invoke: {
            src: ({ token, storeId }) => loyaltyOffersAndRewards({ token, storeId }),
            onDone: {
              target: 'success',
              actions: ['populateMessage'],
            },
            onError: {
              target: 'error',
              actions: ['populateMessage'],
            },
          },
        },
        success: {
          on: {
            IDLE: 'processing',
          },
        },
        error: { type: 'final' },
      },
    },
    {
      actions: {
        populateMessage,
      },
    },
  );

export { createLoyaltyOffersAndRewardsMachine };
